import pdfImg from "../../assets/images/pdfImg.png";
import Img from "../../assets/images/image-icon.png";
import docImg from "../../assets/images/docImg.png";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styles from "../../components/NotificationDrawer/Notifications.module.css";
import BiosynciqIcon from "../../icons/BiosynciqIcon";
import HospitalIcon from "../../icons/HospitalIcon";
import BuildingIcon from "../../icons/BuildingIcon";
import FlashIcon from "../../icons/FlashIcon";
import HomeIcon from "../../icons/HomeIcon";
import StarIcon from "../../icons/StarIcon";
import BriefCaseIcon from "../../icons/BriefCaseIcon";
import { ActiveIcon, InactiveIcon, PendingIcon } from "../../assets/constants";
import PhoneStatusIcon from "../../icons/PhoneStatusIcon";
import InactiveIconContent from "../../components/InactiveIconContent";
import PendingIconContent from "../../components/PendingIconContent";
import ActiveIconContent from "../../components/ActiveIconContent";
import isoWeek from "dayjs/plugin/isoWeek";
import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import EasyImageIcon from "../../assets/images/easy_activity_icon.png";
import ManagebaleImageIcon from "../../assets/images/manageable_activity_icon.png";
import DifficultyImageIcon from "../../assets/images/difficult_activity_icon.png";
import UnableImageIcon from "../../assets/images/unable_activity_icon.png";
import EasyActivityGreyIcon from "../../assets/images/easy_activity_grey_icon.png";
import ManageableActivityGreyIcon from "../../assets/images/manageable_activity_grey_icon.png";
import DifficultActivityGreyIcon from "../../assets/images/difficult_activity_grey_icon.png";
import UnableActivityGreyIcon from "../../assets/images/unable_activity_grey_icon.png";
import {
  getUserTimezone,
  nowInUserTimezone,
  todayInUserTimezone,
  formatDateForApi,
  formatWallClockForApi,
  formatInstantForApi,
  formatApiTimeForDisplay,
  getTimeOptionFromApi,
  getHourFromTimeOption,
  buildLogDateTime,
  isFutureLogDateTime,
} from "./timezone.js";

dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(timezone);

export {
  getUserTimezone,
  nowInUserTimezone,
  todayInUserTimezone,
  formatDateForApi,
  formatWallClockForApi,
  formatInstantForApi,
  formatApiTimeForDisplay,
  getTimeOptionFromApi,
  getHourFromTimeOption,
  buildLogDateTime,
  isFutureLogDateTime,
};

export const formatPainLogTime = (timeValue) =>
  formatApiTimeForDisplay(timeValue);

export const formatTimeEntryTime = (timeValue) =>
  formatApiTimeForDisplay(timeValue);

export const getTimeOptionFromTimeEntry = (timeValue) =>
  getTimeOptionFromApi(timeValue);

export const formatTimeEntryDateForApi = formatDateForApi;

export const formatTimeEntryOptionForApi = formatWallClockForApi;

export const formatUtcForApi = formatInstantForApi;

export function getMyValue(value) {
  if (value === null || value === undefined || value === "null") {
    return;
  }
  return value;
}

export const enrollmentJourneyOptions = [
  {
    title: "All",
    value: "all",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "Enrollment",
    value: "enrolled",
    borderColor: "#3DC583",
    bgColor: "#F3FFF9",
    hoverBgColor: "#2CA068",
  },
  {
    title: "Unenrollment",
    value: "unenrolled",
    bgColor: "#FFEDED",
    borderColor: "#FF2D2D",
    hoverBgColor: "#CC3D3D",
  },
  {
    title: "Consent",
    value: "consent_taken",
    borderColor: "#3DC583",
    bgColor: "#F3FFF9",
    hoverBgColor: "#2CA068",
  },
];

export const activitiesLogs = [
  {
    date: "2025-07-01",
    agency_id: 1,
    patient_id: 1,
    pain_entry_id: null,
    question_types: [
      {
        question_type: "get_out_of_bed",
        question_text: "Did you get out of bed today?",
        answer_text: "easy",
      },
      {
        question_type: "get_dressed",
        question_text: "Did you dress yourself today?",
        answer_text: "manageable",
      },
      {
        question_type: "household_task",
        question_text: "Did you do any household tasks?",
        answer_text: "difficult",
      },
      {
        question_type: "outside_activity",
        question_text: "Did you go outside today?",
        answer_text: "manageable",
      },
    ],
    step_counts: {
      step_count: 4200,
      distance: 3200,
      date: "2025-07-01",
      time: "1970-01-01T07:45:00.000Z",
    },
    created_at: "2025-07-01T08:00:00.000Z",
  },
  {
    date: "2025-07-02",
    agency_id: 1,
    patient_id: 1,
    pain_entry_id: null,
    question_types: [
      {
        question_type: "get_out_of_bed",
        question_text: "Did you get out of bed today?",
        answer_text: "manageable",
      },
      {
        question_type: "get_dressed",
        question_text: "Did you dress yourself today?",
        answer_text: "unable",
      },
      {
        question_type: "household_task",
        question_text: "Did you do any household tasks?",
        answer_text: "manageable",
      },
      {
        question_type: "outside_activity",
        question_text: "Did you go outside today?",
        answer_text: "difficult",
      },
    ],
    step_counts: {
      step_count: 3050,
      distance: 2100,
      date: "2025-07-02",
      time: "1970-01-01T07:50:00.000Z",
    },
    created_at: "2025-07-02T08:10:00.000Z",
  },
  {
    date: "2025-07-03",
    agency_id: 1,
    patient_id: 1,
    pain_entry_id: null,
    question_types: [
      {
        question_type: "get_out_of_bed",
        question_text: "Did you get out of bed today?",
        answer_text: "easy",
      },
      {
        question_type: "get_dressed",
        question_text: "Did you dress yourself today?",
        answer_text: "easy",
      },
      {
        question_type: "household_task",
        question_text: "Did you do any household tasks?",
        answer_text: "manageable",
      },
      {
        question_type: "outside_activity",
        question_text: "Did you go outside today?",
        answer_text: "easy",
      },
    ],
    step_counts: {
      step_count: 6100,
      distance: 4550,
      date: "2025-07-03",
      time: "1970-01-01T08:30:00.000Z",
    },
    created_at: "2025-07-03T08:30:00.000Z",
  },
  {
    date: "2025-07-04",
    agency_id: 1,
    patient_id: 1,
    pain_entry_id: null,
    question_types: [
      {
        question_type: "get_out_of_bed",
        question_text: "Did you get out of bed today?",
        answer_text: "unable",
      },
      {
        question_type: "get_dressed",
        question_text: "Did you dress yourself today?",
        answer_text: "unable",
      },
      {
        question_type: "household_task",
        question_text: "Did you do any household tasks?",
        answer_text: "unable",
      },
      {
        question_type: "outside_activity",
        question_text: "Did you go outside today?",
        answer_text: "unable",
      },
    ],
    step_counts: {
      step_count: 800,
      distance: 620,
      date: "2025-07-04",
      time: "1970-01-01T06:30:00.000Z",
    },
    created_at: "2025-07-04T08:00:00.000Z",
  },
  {
    date: "2025-07-05",
    agency_id: 1,
    patient_id: 1,
    pain_entry_id: null,
    question_types: [
      {
        question_type: "get_out_of_bed",
        question_text: "Did you get out of bed today?",
        answer_text: "manageable",
      },
      {
        question_type: "get_dressed",
        question_text: "Did you dress yourself today?",
        answer_text: "easy",
      },
      {
        question_type: "household_task",
        question_text: "Did you do any household tasks?",
        answer_text: "difficult",
      },
      {
        question_type: "outside_activity",
        question_text: "Did you go outside today?",
        answer_text: "manageable",
      },
    ],
    step_counts: {
      step_count: 3900,
      distance: 2900,
      date: "2025-07-05",
      time: "1970-01-01T07:00:00.000Z",
    },
    created_at: "2025-07-05T08:05:00.000Z",
  },
  {
    date: "2025-07-06",
    agency_id: 1,
    patient_id: 1,
    pain_entry_id: null,
    question_types: [
      {
        question_type: "get_out_of_bed",
        question_text: "Did you get out of bed today?",
        answer_text: "easy",
      },
      {
        question_type: "get_dressed",
        question_text: "Did you dress yourself today?",
        answer_text: "manageable",
      },
      {
        question_type: "household_task",
        question_text: "Did you do any household tasks?",
        answer_text: "manageable",
      },
      {
        question_type: "outside_activity",
        question_text: "Did you go outside today?",
        answer_text: "unable",
      },
    ],
    step_counts: {
      step_count: 4400,
      distance: 3200,
      date: "2025-07-06",
      time: "1970-01-01T08:10:00.000Z",
    },
    created_at: "2025-07-06T08:15:00.000Z",
  },
  {
    date: "2025-07-07",
    agency_id: 1,
    patient_id: 1,
    pain_entry_id: null,
    question_types: [
      {
        question_type: "get_out_of_bed",
        question_text: "Did you get out of bed today?",
        answer_text: "manageable",
      },
      {
        question_type: "get_dressed",
        question_text: "Did you dress yourself today?",
        answer_text: "difficult",
      },
      {
        question_type: "household_task",
        question_text: "Did you do any household tasks?",
        answer_text: "easy",
      },
      {
        question_type: "outside_activity",
        question_text: "Did you go outside today?",
        answer_text: "easy",
      },
    ],
    step_counts: {
      step_count: 3700,
      distance: 2750,
      date: "2025-07-07",
      time: "1970-01-01T07:35:00.000Z",
    },
    created_at: "2025-07-07T08:25:00.000Z",
  },
];

export const questionTypeMeta = {
  get_out_of_bed: {
    label: "Getting out of bed",
    icon: EasyActivityGreyIcon,
  },
  get_dressed: {
    label: "Getting dressed",
    icon: ManageableActivityGreyIcon,
  },
  household_task: {
    label: "Doing House Chores",
    icon: DifficultActivityGreyIcon,
  },
  outside_activity: {
    label: "Doing Outside Work",
    icon: UnableActivityGreyIcon,
  },
};

export const chartActivitiesLogs = [
  {
    date: "06-24-2025",
    out_of_bed: "unable",
    getting_dressed: "difficult",
    house_chores: "manageable",
    outside_work: "easy",
  },
  {
    date: "06-23-2025",
    out_of_bed: "manageable",
    getting_dressed: "difficult",
    house_chores: "easy",
    outside_work: "unable",
  },
  {
    date: "06-22-2025",
    out_of_bed: "easy",
    getting_dressed: "unable",
    house_chores: "manageable",
    outside_work: "difficult",
  },
  {
    date: "06-21-2025",
    out_of_bed: "easy",
    getting_dressed: "difficult",
    house_chores: "manageable",
    outside_work: "unable",
  },
  {
    date: "06-20-2025",
    out_of_bed: "manageable",
    getting_dressed: "difficult",
    house_chores: "easy",
    outside_work: "unable",
  },
  {
    date: "06-19-2025",
    out_of_bed: "easy",
    getting_dressed: "difficult",
    house_chores: "manageable",
    outside_work: "unable",
  },
  {
    date: "06-18-2025",
    out_of_bed: "easy",
    getting_dressed: "difficult",
    house_chores: "manageable",
    outside_work: "unable",
  },
  {
    date: "06-17-2025",
    out_of_bed: "easy",
    getting_dressed: "difficult",
    house_chores: "manageable",
    outside_work: "unable",
  },
  {
    date: "06-16-2025",
    out_of_bed: "easy",
    getting_dressed: "difficult",
    house_chores: "manageable",
    outside_work: "unable",
  },
  {
    date: "06-15-2025",
    out_of_bed: "easy",
    getting_dressed: "difficult",
    house_chores: "manageable",
    outside_work: "unable",
  },
];

export const statusMap = {
  "-": { value: 0, label: "-", fullLabel: "-" },
  easy: { value: 1, label: "E", fullLabel: "Easy", color: "#F1B62E" },
  manageable: {
    value: 2,
    label: "M",
    fullLabel: "Manageable",
    color: "#F765A3",
  },
  difficult: {
    value: 3,
    label: "D",
    fullLabel: "Difficult",
    color: "#5BAF87",
  },
  unable: { value: 4, label: "U", fullLabel: "Unable", color: "#0C80F3" },
};

export const activityKeys = [
  "get_out_of_bed",
  "get_dressed",
  "household_task",
  "outside_activity",
];

export const activitesOptions = [
  { title: "get_out_of_bed", icon: EasyImageIcon, color: "#F1B62E" },
  { title: "get_dressed", icon: ManagebaleImageIcon, color: "#F765A3" },
  { title: "household_task", icon: DifficultyImageIcon, color: "#5BAF87" },
  { title: "outside_activity", icon: UnableImageIcon, color: "#0C80F3" },
];

export const formatLastReadingTime = (dateString) => {
  const date = dayjs(dateString).startOf("day");
  const today = dayjs().startOf("day");
  const daysDiff = today.diff(date, "day");

  if (daysDiff === 0) {
    return "Today";
  } else if (daysDiff === 1) {
    return "Yesterday";
  } else if (daysDiff <= 7) {
    return `${daysDiff} days ago`;
  } else {
    return date.format("DD MMMM");
  }
};

const getAggregationState = (differenceInDays) => {
  if (differenceInDays <= 1) {
    return "1h";
  } else if (differenceInDays <= 31) {
    return "default";
  } else {
    return "monthly";
  }
};

export const getAggregationViewForMTD = () => {
  const today = dayjs();
  const startOfMonth = today.startOf("month");
  const differenceInDays = today.diff(startOfMonth, "day");

  return getAggregationState(differenceInDays);
};

export const getAggregationViewForCustomDate = (startDate, endDate) => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  const differenceInDays = end?.diff(start, "day");
  return getAggregationState(differenceInDays);
};

const getAggregationOptionsByDays = (differenceInDays) => {
  if (differenceInDays <= 1) {
    return [
      { title: "1H", value: "1h" },
      { title: "3H", value: "3h" },
      { title: "6H", value: "6h" },
    ];
  } else if (differenceInDays <= 7) {
    return [
      { title: "Daily", value: "default" },
      { title: "12H", value: "12h" },
    ];
  } else if (differenceInDays <= 14) {
    return [
      { title: "Daily", value: "default" },
      { title: "3D", value: "days" },
    ];
  } else if (differenceInDays <= 31) {
    return [
      { title: "Daily", value: "default" },
      { title: "Weekly", value: "weekly" },
    ];
  } else if (differenceInDays <= 183) {
    return [
      { title: "Monthly", value: "monthly" },
      { title: "Weekly", value: "weekly" },
    ];
  } else {
    return [{ title: "Monthly", value: "monthly" }];
  }
};

export const labsData = [
  {
    title: "LAB_20250220_1111.pdf",
    date: "10:05am, 18 July",
    status: "consistent",
  },
  {
    title: "LAB_20250220_2222.pdf",
    date: "10:05am, 18 August",
    status: "inconsistent",
  },
  {
    title: "LAB_20250220_3333.pdf",
    date: "10:05am, 18 September",
    status: "consistent",
  },
  {
    title: "LAB_20250220_4444.pdf",
    date: "10:05am, 18 November",
    status: "inconsistent",
  },
  {
    title: "LAB_20250220_5555.pdf",
    date: "10:05am, 18 December",
    status: "consistent",
  },
  {
    title: "LAB_20250220_6666.pdf",
    date: "10:05am, 18 July",
    status: "consistent",
  },
];

export const getAggregationOptions = (
  painLogDays,
  startDate = null,
  endDate = null
) => {
  if (painLogDays?.toString() === "mtd") {
    const today = dayjs();
    const startOfMonth = today.startOf("month");
    const differenceInDays = today.diff(startOfMonth, "day");
    return getAggregationOptionsByDays(differenceInDays);
  }

  if (painLogDays === "custom" && startDate && endDate) {
    const differenceInDays = endDate?.diff(startDate, "day");
    return getAggregationOptionsByDays(differenceInDays);
  }

  const predefinedDays = {
    7: 7,
    14: 14,
    28: 28,
    "24h": 1,
    31: 31,
    92: 92,
    183: 183,
    365: 365,
  };

  const differenceInDays = predefinedDays[painLogDays?.toString()];
  return differenceInDays ? getAggregationOptionsByDays(differenceInDays) : [];
};

export const getXLabelOptions = (aggregationView, labelsChartData) => {
  const minDate = dayjs(labelsChartData[0], "MM/DD/YYYY");
  const maxDate = dayjs(
    labelsChartData[labelsChartData.length - 1],
    "MM/DD/YYYY"
  );

  const min = minDate.isValid()
    ? minDate.startOf("day").toISOString()
    : undefined;
  const max = maxDate.isValid()
    ? maxDate.endOf("day").toISOString()
    : undefined;

  switch (aggregationView) {
    case "12h":
      return {
        type: "time",
        time: {
          unit: "hour",
          tooltipFormat: "",
          displayFormats: {
            hour: "",
          },
        },
        title: {
          display: true,
        },

        ticks: {
          autoSkip: false,
          source: "auto",
          major: {
            enabled: true,
          },
          font: {
            size: 10,
            weight: (ctx) => {
              const date = dayjs(ctx.tick.value);
              return date.format("A") === "PM" && date.hour() % 12 === 0
                ? "bold"
                : "normal";
            },
          },
          callback: function (value, index, values) {
            const date = dayjs(value);
            if (date.format("A") === "AM") {
              return date.format("DD MMM");
            } else if (date.format("A") === "PM" && date.hour() % 12 === 0) {
              return "12";
            } else if (index === values.length - 1) {
              return date.format("DD MMM");
            }
            return "";
          },
          maxRotation: 0,
          minRotation: 0,
        },
        min: min,
        max: max,
      };

    case "1h":
    case "3h":
    case "6h":
      return {
        type: "time",
        time: {
          unit: "hour",
          tooltipFormat: "MM/DD hh:mm A",
          displayFormats: {
            hour: "hh A",
          },
        },
        min: dayjs().subtract(24, "hour").toISOString(),
        max: dayjs().toISOString(),
        title: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          stepSize: aggregationView[0],
          source: "auto",
          major: {
            enabled: false,
          },
          font: {
            size: 10,
          },
        },
      };

    default:
      return {};
  }
};

export const logValueOptions = [
  { title: "Therapeutic Data Review", value: "Therapeutic Data Review" },
  { title: "Communication with Patient", value: "Communication with Patient" },
  { title: "Chart Review", value: "Chart Review" },
  { title: "Care Coordination", value: "Care Coordination" },
  { title: "Other", value: "Other" },
];

export const programOptions = [
  { title: "All", value: "all" },
  { title: "Not Assigned", value: "not_assigned" },
  { title: "RTM", value: "RTM" },
  { title: "PCM", value: "PCM" },
  { title: "CCM", value: "CCM" },
];

export const enrollmentOptions = [
  { title: "All", value: "all" },
  { title: "Pending", value: "pending" },
  { title: "Enrolled", value: "enrolled" },
  { title: "Un-enrolled", value: "unenrolled" },
];

export const appActivityOptions = [
  { title: "All", value: "all" },
  { title: "Credentials Never Sent", value: "credentials_never_sent" },
  { title: "Never Logged in ", value: "never_logged_in" },
];

export const addedOnOptions = [
  { title: "All", value: "all" },
  { title: "Today", value: "today" },
  { title: "Last week", value: "last_week" },
  { title: "Last month", value: "last_month" },
  { title: "Last 3 months", value: "last_3_months" },
  { title: "Custom", value: "custom_period" },
];

export const credentialsOptions = [
  { title: "All", value: "all" },
  { title: "Sent", value: true },
  { title: "Not Sent", value: false },
];

export const addedViaOptions = [
  { title: "All", value: "all", column: "left" },
  { title: "Manually Added", value: "manually_added", column: "left" },
  { title: "Bulk Import", value: "bulk_import", column: "left" },

  { title: "Self Signup", value: "self_signup", column: "right" },
  { title: "RevCare", value: "revcare", column: "right" },
];

export const consentStatusOptions = [
  { title: "All", value: "all" },
  { title: "Completed", value: "true" },
  { title: "Pending", value: "false" },
];

export const deviceEducationOptions = [
  { title: "All", value: "all" },
  { title: "Completed", value: "true" },
  { title: "Pending", value: "false" },
];

export const enrollmentStatusOptions = [
  { title: "All", value: "all" },
  { title: "Enrolled", value: "enrolled" },
  { title: "Not Enrolled", value: "pending" },
];

export const statusOptions = [
  { title: "All", value: "all" },
  { title: "Active", value: "active" },
  { title: "Inactive", value: "inactive" },
];

export const formatElapsedTime = (elapsed, hms = true) => {
  const hours = Math.floor(elapsed / 3600000)
    .toString()
    .padStart(2, "0");
  const minutes = Math.floor((elapsed % 3600000) / 60000)
    .toString()
    .padStart(2, "0");
  const seconds = Math.floor((elapsed % 60000) / 1000)
    .toString()
    .padStart(2, "0");

  let formattedTime = "";

  if (hours > 0) {
    formattedTime += `${hours}h `;
  }

  if (minutes > 0) {
    formattedTime += `${minutes}m `;
  }

  if (seconds > 0) {
    formattedTime += `${seconds}s `;
  }

  return hms ? `${formattedTime}` : `${hours}:${minutes}:${seconds}`;
};

/* utils/chartHelpers.js */
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

// MONTHLY CHART VIEW
export const toMonthlyAverage = (raw) => {
  const monthBuckets = {};

  raw.labels.forEach((lbl, i) => {
    const date = dayjs(lbl); // lbl = "MM/DD/YYYY"
    const monthKey = date.format("YYYY-MM"); // "2024-04"
    (monthBuckets[monthKey] ||= []).push(i);
  });

  const sortedMonthKeys = Object.keys(monthBuckets).sort(); // chronological order

  // Build labels (e.g., ["Apr", "May", ..., "Apr"])
  const labels = sortedMonthKeys.map((key) => {
    const monthNum = parseInt(key.split("-")[1], 10); // 04 → 4
    return MONTHS[monthNum - 1];
  });

  // Filter out bars, average data per month
  const datasets = raw.datasets
    .filter((d) => d.type !== "bar")
    .map((d) => {
      const data = sortedMonthKeys.map((key) => {
        const indices = monthBuckets[key];
        const vals = indices.map((i) => d.data[i]).filter((v) => v != null);
        return vals.length
          ? vals.reduce((sum, v) => sum + v, 0) / vals.length
          : null;
      });
      return { ...d, data };
    });

  return { labels, datasets };
};

// WEEKLY CHART VIEW
export const toWeeklyAverage = (raw) => {
  const weekBuckets = {};

  const today = dayjs();
  const twelveMonthsAgo = today.subtract(12, "month");

  raw.labels.forEach((lbl, i) => {
    const date = dayjs(lbl, "MM/DD/YYYY"); // expects full date format
    if (date.isBefore(twelveMonthsAgo)) return;

    const weekKey = `${date.year()}-W${date.isoWeek()}`; // e.g., "2024-W14"
    (weekBuckets[weekKey] ||= []).push({ index: i, date });
  });

  const sortedWeekKeys = Object.entries(weekBuckets).sort(([keyA], [keyB]) =>
    dayjs(keyA, "YYYY-[W]WW").diff(dayjs(keyB, "YYYY-[W]WW"))
  );

  const labels = sortedWeekKeys.map(([, entries]) => {
    const dates = entries.map((e) => e.date).sort((a, b) => a - b);
    const start = dates[0].format("MMM DD");
    const end = dates[dates.length - 1].format("MMM DD");
    return `${start} - ${end}`;
  });

  const datasets = raw.datasets
    .filter((d) => d.type !== "bar")
    .map((d) => {
      const data = sortedWeekKeys.map(([, entries]) => {
        const vals = entries
          .map(({ index }) => d.data[index])
          .filter((v) => v != null);
        return vals.length
          ? vals.reduce((sum, v) => sum + v, 0) / vals.length
          : null;
      });
      return { ...d, data };
    });

  return { labels, datasets };
};

// 3 DAY CHART VIEW
export const to3DayAverage = (raw) => {
  const today = dayjs();
  const twelveMonthsAgo = today.subtract(12, "month");

  // Parse dates and filter
  const parsedDates = raw.labels
    .map((lbl, i) => ({
      index: i,
      date: dayjs(lbl, "MM/DD/YYYY"),
      originalLabel: lbl,
    }))
    .filter(({ date }) => date.isAfter(twelveMonthsAgo))
    .sort((a, b) => a.date - b.date);

  const labels = parsedDates.map(({ date }, idx) => {
    // Show label every 3rd index, hide others
    return idx % 3 === 0 ? date.format("M/D") : "";
  });

  const datasets = raw.datasets
    .filter((d) => d.type !== "bar")
    .map((d) => {
      const data = parsedDates.map(({ index }) => d.data[index] ?? null);
      return {
        ...d,
        data,
      };
    });

  return { labels, datasets };
};

export const formatBodyPartLabel = (side, name) => {
  const capitalizedSide = side?.charAt(0).toUpperCase() + side?.slice(1);
  return `${capitalizedSide} ${name}`;
};

export const formatElapsedTimeForListing = (elapsed) => {
  const hours = Math.floor(elapsed / 3600000);
  const minutes = Math.floor((elapsed % 3600000) / 60000);
  return hours ? `${hours} hrs ${minutes} min` : `${minutes} min`;
};

export const humanReadingTime = (totalSeconds) => {
  if (totalSeconds < 60) {
    return `${totalSeconds} second${totalSeconds === 1 ? "" : "s"}`;
  } else if (totalSeconds < 3600) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return seconds > 0
      ? `${minutes} minute${minutes === 1 ? "" : "s"} and ${seconds} second${
          seconds === 1 ? "" : "s"
        }`
      : `${minutes} minute${minutes === 1 ? "" : "s"}`;
  } else {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    return minutes > 0
      ? `${hours} hour${hours === 1 ? "" : "s"} and ${minutes} minute${
          minutes === 1 ? "" : "s"
        }`
      : `${hours} hour${hours === 1 ? "" : "s"}`;
  }
};

export function sortByDateAndTime(items) {
  return items.slice().sort((a, b) => {
    const dateA = new Date(a.date);
    const dateB = new Date(b.date);

    if (dateA < dateB) return -1;
    if (dateA > dateB) return 1;

    // If dates are the same, then compare by time
    const timeA = new Date(a.time);
    const timeB = new Date(b.time);
    return timeA - timeB;
  });
}

export const humanReadingNames = (patients, bulkActions = false) => {
  const names = bulkActions
    ? patients?.map((item) => item?.patient?.name)
    : patients?.map((item) => item?.name);
  if (names?.length === 1) {
    return `have been added for ${names[0]}.`;
  }
  if (names?.length === 2) {
    return `have been added for each ${names[0]} and ${names[1]}.`;
  }
  if (names?.length > 2) {
    const [first, second, ...rest] = names;
    return `have been added for each ${first}, ${second} and ${
      rest?.length
    } other ${rest?.length === 1 ? "patient" : "patients"}.`;
  }
};

export const paymentText = (type) => {
  if (type === "card") {
    return "Credit Card";
  } else if (type === "link") {
    return "Link";
  } else if (type === "us_bank_account") {
    return "Bank Account";
  } else {
    return "None";
  }
};

export const calculateElapsedTime = (startTime, endTime) => {
  const start = dayjs(startTime)?.set("second", 0).set("millisecond", 0);
  const end = dayjs(endTime)?.set("second", 0).set("millisecond", 0);
  return end.diff(start, "second");
};

export const hoursOptions = Array.from({ length: 12 }, (_, i) => {
  const values = (i + 1).toString().padStart(2, "0");
  return { title: values, value: values };
});
export const minutesOptions = Array.from({ length: 60 }, (_, i) => {
  const values = i.toString().padStart(2, "0");
  return { title: values, value: values };
});

export const amPmOptions = [
  { title: "AM", value: "AM" },
  { title: "PM", value: "PM" },
];

export const quickTimeOptions = [
  { label: "1 min", value: "1" },
  { label: "2 min", value: "2" },
  { label: "3 min", value: "3" },
  { label: "5 min", value: "5" },
  { label: "8 min", value: "8" },
  { label: "15 min", value: "15" },
];

// export const formatElapsedTime = (elapsed) => {
//   const hours = Math.floor(elapsed / 3600)
//     .toString()
//     .padStart(2, "0");
//   const minutes = Math.floor((elapsed % 3600) / 60)
//     .toString()
//     .padStart(2, "0");
//   const seconds = Math.floor(elapsed % 60)
//     .toString()
//     .padStart(2, "0");
//   return `${hours}:${minutes}:${seconds}`;
// };

export function stringAvatar(name) {
  const newName = name
    ? name?.replace(/[^a-zA-Z0-9]/g, " ")?.replace(/\s\s+/g, " ")
    : "BiosyncIQ";
  return {
    children: `${newName?.split(" ")[0][0]}${
      newName?.split(" ")[1] ? newName?.split(" ")[1][0] : ""
    }`,
  };
}

export function getIconColor(iconColor) {
  let bgColor;
  switch (iconColor) {
    case "green":
      bgColor = "linear-gradient(136deg, #00D55A 7.5%, #007257 93.77%)";
      break;
    case "blue":
      bgColor = "linear-gradient(136deg, #4CA4EC 7.5%, #2C5FFE 93.77%)";
      break;
    case "red":
      bgColor = "linear-gradient(136deg, #D33D3E 7.5%, #812526 93.77%)";
      break;
    case "violet":
      bgColor = "linear-gradient(136deg, #9249F1 7.5%, #63338E 93.77%)";
      break;

    default:
      bgColor = "linear-gradient(136deg, #4CA4EC 7.5%, #2C5FFE 93.77%)";
      break;
  }

  return bgColor;
}

// { iconName: <BriefCaseIcon />, value: "briefcase_icon", icon: true },

export function getIconName(iconName) {
  let icon;
  switch (iconName) {
    case "biosynciq_icon":
      icon = <BiosynciqIcon color="#fff" />;
      break;
    case "hospital_icon":
      icon = <HospitalIcon color="#fff" />;
      break;
    case "building_icon":
      icon = <BuildingIcon color="#fff" />;
      break;
    case "flash_icon":
      icon = <FlashIcon color="#fff" />;
      break;
    case "home_icon":
      icon = <HomeIcon color="#fff" />;
      break;
    case "star_icon":
      icon = <StarIcon color="#fff" />;
      break;
    case "briefcase_icon":
      icon = <BriefCaseIcon color="#fff" />;
      break;

    default:
      icon = <BiosynciqIcon color="#fff" />;
      break;
  }

  return icon;
}

export const getLogTypeValues = (logType) => {
  let logTypeValue;
  switch (logType) {
    case "chat_communication":
      logTypeValue = "Chat & Communication";
      break;
    case "All":
      logTypeValue = "All";
      break;
    default:
      logTypeValue = "All";
      break;
  }

  return logTypeValue;
};

export const unEnrollmentManualReasonOptions = [
  { title: "Deductible Issues", value: "Deductible Issues" },
  { title: "Change of Insurance", value: "Change of Insurance" },
  { title: "No longer in Pain", value: "No longer in Pain" },
  { title: "Deceased", value: "Deceased" },
  { title: "Not Active / No Engagement", value: "Not Active / No Engagement" },
  { title: "Not Interested", value: "Not Interested" },
  { title: "Other", value: "Other" },
];

export const unEnrollmentReasonsOptions = [
  { title: "All", value: "all" },
  ...unEnrollmentManualReasonOptions,
  {
    title: "Inactive monitoring (auto-unenrolled)",
    value: "dormancy_3_months",
  },
];

/** Human-readable labels for stored unenrollment / deactivation reason codes. */
export const getUnenrollmentReasonDisplay = (reason) => {
  if (!reason) {
    return { label: "-", description: null, isSystem: false };
  }

  const reasonMap = {
    dormancy_3_months: {
      label: "Inactive monitoring (auto-unenrolled)",
      description:
        "Automatically unenrolled after 3 consecutive calendar months with no qualifying remote monitoring data. The patient can be re-enrolled if care resumes.",
      isSystem: true,
    },
    "Not Active / No Engagement": {
      label: "Not Active / No Engagement",
      description:
        "Manually unenrolled because the patient was not actively engaging with the program.",
      isSystem: false,
    },
    "Deductible Issues": {
      label: "Deductible Issues",
      description: null,
      isSystem: false,
    },
    "Change of Insurance": {
      label: "Change of Insurance",
      description: null,
      isSystem: false,
    },
    "No longer in Pain": {
      label: "No longer in Pain",
      description: null,
      isSystem: false,
    },
    Deceased: {
      label: "Deceased",
      description: null,
      isSystem: false,
    },
    "Not Interested": {
      label: "Not Interested",
      description: null,
      isSystem: false,
    },
    Other: {
      label: "Other",
      description: null,
      isSystem: false,
    },
    manual: {
      label: "Manual unenrollment",
      description: null,
      isSystem: false,
    },
    deleted: {
      label: "Patient deleted",
      description: null,
      isSystem: false,
    },
  };

  if (reasonMap[reason]) {
    return reasonMap[reason];
  }

  // Fallback for unknown snake_case / kebab codes
  if (/[_-]/.test(reason)) {
    const label = reason
      .replace(/[_-]+/g, " ")
      .replace(/\b\w/g, (c) => c.toUpperCase());
    return { label, description: null, isSystem: false };
  }

  return { label: reason, description: null, isSystem: false };
};

export function getRandomBackgroundColor(index) {
  const colors = [
    "#0C80F3",
    "rgb(255, 99, 132)",
    "rgb(255, 205, 86)",
    "rgb(75, 192, 192)",
    "#8BC34A",
    "#E91E63",
    "#795548",
    "#FF9800",
    "#03A9F4",
    "#009688",
    "#3F3CD8",
    "#F44336",
  ];
  return colors[index % colors.length] || "rgb(153, 102, 255)";
}

export function getStepCountDaysText(days) {
  let formatText;
  switch (days) {
    case "mtd":
      formatText = "MTD";
      break;

    case 14:
      formatText = "Last 14 Days";
      break;

    case 31:
      formatText = "Last 1 Month";
      break;
    case 92:
      formatText = "Last 3 Months";
      break;
    case 365:
      formatText = "Last 12 Months";
      break;

    default:
      formatText = "Custom";
      break;
  }

  return formatText;
}

export function getAppointmentDays(startDate) {
  const daysDiff = dayjs().diff(dayjs(startDate), "day");

  if (daysDiff <= 7) {
    return "mtd";
  } else if (daysDiff <= 14) {
    return 14;
  } else if (daysDiff <= 31) {
    return 31;
  } else if (daysDiff <= 92) {
    return 92;
  } else if (daysDiff > 92) {
    return 365;
  } else {
    return "custom";
  }
}

export function removeLastExtension(fileName) {
  const lastDotIndex = fileName?.lastIndexOf(".");

  if (lastDotIndex !== -1) {
    const nameWithoutExtension = fileName?.substring(0, lastDotIndex);
    const extension = fileName?.substring(lastDotIndex);

    return { nameWithoutExtension, extension };
  } else {
    // No extension found
    return fileName;
  }
}

export const bodyPainWord = (bodyPartName) => {
  const formattedBodyPartName = bodyPartName.replace("-", " ");
  return formattedBodyPartName;
};

export const exportPdfPainData = (allData) => {
  const painTableData = [];
  let srNo = 1;

  // Loop over allData
  allData?.forEach((data, index) => {
    const createdTime = data?.created_at
      ? dayjs(data?.created_at).format("hh:mm A")
      : "-";
    const parsedData = JSON.parse(data?.body_parts_data);

    // Loop over body_parts_data
    parsedData?.forEach((bodyPart, bodyPartIndex) => {
      const row = [
        srNo++,
        data?.date,
        createdTime,
        `${bodyPart?.side}-${bodyPart?.name}`,
        bodyPart?.pain_scale,
        bodyPart?.description ? bodyPart?.description : "-",
      ];
      painTableData.push(row);
    });
  });

  return painTableData;
};

export const checkFileExtension = (fileName) => {
  const fileExtension = fileName?.split(".")?.pop();

  const imageExtensions = ["jpg", "jpeg", "png"];

  const isImage = imageExtensions?.includes(fileExtension?.toLowerCase());
  return isImage;
};

export const onlyImageName = (imageName) => {
  const parts = imageName?.split(".");

  const nameWithoutExtension = parts?.slice(0, -1)?.join(".");

  return nameWithoutExtension;
};

export const getCaseValueText = (caseValue) => {
  const option = caseTypeOptions.find((option) => option.value === caseValue);
  return option ? option.title : caseValue;
};

export const isPDF = (fileName) => {
  return fileName.toLowerCase().endsWith(".pdf");
};

const showMedicationText = (medication) => {
  if (medication === "no") {
    return "Medication missed";
  } else if (medication === "na") {
    return "Medication not prescribed";
  } else if (medication === "yes") {
    return "Medication taken";
  }
};

export const appointmentTypeOptions = [
  { title: "Doctor's Appointment", value: "Doctor's Appointment" },
  { title: "Urine Sample Collection", value: "Urine Sample Collection" },
  { title: "Other", value: "Other" },
];

export const dateFrequencyOptions = [
  { title: "Daily", value: "Daily" },
  { title: "Weekly", value: "Weekly" },
  { title: "Monthly", value: "Monthly" },
];

export const timeNotesOptions = [
  { title: "1 Minute", value: "1_minute" },
  { title: "2 Minutes", value: "2_minutes" },
  { title: "3 Minutes", value: "3_minutes" },
  { title: "4 Minutes", value: "4_minutes" },
  { title: "5 Minutes", value: "5_minutes" },
];

export const generatePassword = (length) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()";

  let password = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    password += characters.charAt(randomIndex);
  }

  return password;
};

export const calculateBulkTimeMinutes = (timeValue) => {
  const durationInMinute = parseInt(timeValue.split("_")[0]);

  const endTime = dayjs();
  const startTime = endTime.subtract(durationInMinute, "minute");

  return {
    startTime,
    endTime,
  };
};

export const exportCsvData = (allData) => {
  const csvData = [];
  let srNo = 1;

  // Adding CSV headers
  csvData?.push([
    "Sr No.",
    "Date",
    "Time",
    "Body Part",
    "Duration",
    "Pain Intensity",
    "Medication",
    "Comments",
  ]);

  // Loop over allData
  allData?.forEach((data, index) => {
    const createdTime = data?.created_at
      ? dayjs(data?.created_at)?.format("hh:mm A")
      : "-";

    // Loop over body_parts_data
    data?.body_parts_data?.forEach((bodyPart, bodyPartIndex) => {
      const sleepLoss = showMedicationText(bodyPart?.medicine_adherence);
      const painDurationValue = data?.duration
        ? painDurationValues[data?.duration]
        : "-";

      const row = [
        srNo++,
        data?.date,
        createdTime,
        `${bodyPart?.side}-${bodyPart?.name}`,
        painDurationValue,
        bodyPart?.pain_scale,
        sleepLoss,
        bodyPart?.description,
      ];
      csvData.push(row);
    });
  });

  return csvData;
};

export const validateEmail = (inputEmail) => {
  const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(inputEmail);
};

export const clearContact = (phoneNumber) => {
  return phoneNumber.replace(/[+() ]/g, "");
};

export const formatPhoneNumber = (input) => {
  const numericInput = input.replace(/^1/, "").replace(/\D/g, ""); // Remove non-numeric characters from input

  if (numericInput.length === 0) {
    return "";
  }

  let formattedNumber = "+1 ";
  if (numericInput.length >= 1) {
    formattedNumber += `(${numericInput.slice(0, 3)}`;
  }
  if (numericInput.length >= 4) {
    formattedNumber += `) ${numericInput.slice(3, 6)}`;
  }
  if (numericInput.length >= 7) {
    formattedNumber += `-${numericInput.slice(6, 10)}`;
  }

  return formattedNumber;
};

export const isSupportedType = (filename) => {
  const extension = filename?.split(".")?.pop()?.toLowerCase();
  return ["jpg", "jpeg", "png", "gif", "mp4", "webm", "ogg"]?.includes(
    extension
  );
};

export const timeAgo = (createdAt) => {
  const formattedTime = dayjs(createdAt).fromNow();

  return formattedTime;
};

export const monthFilterOptions = [
  { title: "This Month", value: "this_month" },
  { title: "Last Month", value: "last_month" },
  // {
  //   title: dayjs().subtract(2, "month").format("MMMM YYYY"),
  //   value: dayjs().subtract(2, "month").format("YYYY-MM"),
  // },
];

const formatMonthYear = (date) => dayjs(date).format("MMMM 'YY");

const getMonthsTillEnrollment = (enrolledOn, bulkActions) => {
  if (bulkActions) {
    const currentMonth = dayjs();
    const lastMonth = currentMonth?.subtract(1, "month");
    const lastToLastMonth = currentMonth?.subtract(2, "month");

    return [
      {
        title: formatMonthYear(lastMonth),
        value: lastMonth.format("YYYY-MM"),
      },
      {
        title: formatMonthYear(lastToLastMonth),
        value: lastToLastMonth.format("YYYY-MM"),
      },
    ];
  }

  const enrollmentDate = dayjs(enrolledOn);
  const months = [];
  let currentDate = dayjs().subtract(1, "month");

  while (
    currentDate.isAfter(enrollmentDate) ||
    currentDate.isSame(enrollmentDate, "month")
  ) {
    months.push({
      title: formatMonthYear(currentDate),
      value: currentDate.format("YYYY-MM"),
    });
    currentDate = currentDate.subtract(1, "month"); // Move back one month
  }

  return months;
};

export const reportMonthFilterOptions = (
  enrolledOn,
  bulkActions = false,
  customText = false
) => {
  return [
    { title: customText ? "This Month" : "Month to date", value: "this_month" },
    ...getMonthsTillEnrollment(enrolledOn, bulkActions),
  ];
};

export const payerOptions = [
  { title: "All", value: "all" },
  { title: "Medicare", value: "medicare" },
  { title: "Medicaid", value: "medicaid" },
];

export const calculateDaysSinceLastLogin = (lastReadingTime) => {
  if (!lastReadingTime) return null;

  const currentDate = dayjs();
  const daysDifference = currentDate.diff(dayjs(lastReadingTime), "day");

  return daysDifference;
};

export const calculateAppStatus = (firstLogin, lastReadingTime) => {
  const currentDate = dayjs();
  const daysDifference = lastReadingTime
    ? currentDate?.diff(dayjs(lastReadingTime), "day")
    : null;

  if (!firstLogin) {
    return "never_logged_in";
  }

  if (!lastReadingTime) {
    return "pending";
  }

  if (
    daysDifference === null ||
    daysDifference === undefined ||
    daysDifference > 7
  ) {
    return "inactive";
  }

  return "active";
};

export function getMobileAppStatus({
  enrolments = [],
  enrollment_status,
  creation_flow,
  ever_logged_in,
  ever_logged_pain,
  days_since_last_login = 0,
  patientName,
}) {
  const hasEnrolments = enrolments?.length > 0;

  // ---------------------------------------------------
  // DISABLED STATES
  // ---------------------------------------------------
  if (!hasEnrolments || enrollment_status === "unenrolled") {
    // Case 1: Unenrolled
    if (enrollment_status === "unenrolled") {
      return {
        icon: "rgba(0, 0, 0, 0.38)",
        title: "Mobile App - Disabled",
        subtitle: `${patientName} is unenrolled from all programs, and mobile app access has been disabled.`,
      };
    }

    // Case 2: Self-signup OR QR
    if (creation_flow === "self_signup" || creation_flow === "qr_code_scan") {
      return {
        icon: "rgba(0, 0, 0, 0.38)",
        title: "Mobile App - Disabled",
        subtitle: `${patientName} signed up using the link/QR code but isn't enrolled in any program yet.`,
      };
    }

    // Case 3: Default fallback
    return {
      icon: "rgba(0, 0, 0, 0.38)",
      title: "Mobile App - Disabled",
      subtitle: `${patientName} is not enrolled in any program, and no mobile app credentials have been sent yet.`,
    };
  }

  // ---------------------------------------------------
  // 2️⃣ NEVER LOGGED IN STATES
  // ---------------------------------------------------
  if (!ever_logged_in) {
    // Pending → Program Registered
    if (enrollment_status === "pending") {
      return {
        icon: "#212121",
        title: "Mobile App - Never Logged In",
        subtitle: `${patientName} has been registered in a program, and the credentials were sent, but they haven't logged in to the mobile app yet.`,
      };
    }

    // Enrolled → Program Enrolled
    if (enrollment_status === "enrolled") {
      return {
        icon: "#212121",
        title: "Mobile App - Never Logged In",
        subtitle: `${patientName} has been enrolled, and the credentials were sent, but they haven't logged in to the mobile app yet.`,
      };
    }
  }

  // ---------------------------------------------------
  // 3️⃣ INACTIVE STATES
  // ---------------------------------------------------
  // Never logged pain
  if (!ever_logged_pain) {
    return {
      icon: "#FF852D",
      title: "Mobile App - Inactive",
      subtitle: `${patientName} is enrolled & has logged in but never logged any reading. `,
    };
  }

  // Didn't log for 7+ days
  if (days_since_last_login > 7) {
    return {
      icon: "#FF852D",
      title: "Mobile App - Inactive",
      subtitle: `${patientName} is inactive and hasn't logged any reading in last 7 days.`,
    };
  }

  // ---------------------------------------------------
  // 4️⃣ ACTIVE
  // ---------------------------------------------------
  return {
    icon: "#3DC583",
    title: "Mobile App - Active",
    subtitle: `${patientName} is enrolled and actively using the mobile app.`,
  };
}

export const secondsToMinutesCeil = (seconds = 0) => Math.ceil(seconds / 60);

export const cptCodesBaseTime = {
  98980: 1200,
  98981: 1200,
  99491: 1200,
  99437: 1200,

  99424: 1800,
  99425: 1800,
  99426: 1800,
  99427: 1800,
  99490: 1800,
  99439: 1800,

  98979: 600,
};

/** Qualifying device-monitoring interaction types for 98985 / 98977 progress. */
export const QUALIFYING_DEVICE_TRANSMISSION_TYPES = [
  "pain_entry",
  "medicine_entry",
  "app_activation",
];

export const MUSCULOSKELETAL_MIN_DAYS = 2;
export const DEFAULT_DAYS_LIMIT_FOR_77 = 16;
/** 98975 initial-setup export threshold (matches pain_entry / medicine_entry backend). */
export const SETUP_QUALIFYING_DAYS_FOR_EXPORT = 16;

/** Qualifying types for 98975 initial-setup progress (matches backend). */
export const QUALIFYING_SETUP_TRANSMISSION_TYPES = [
  "pain_entry",
  "medicine_entry",
];

export const parseCptTransmissions = (transmissions) => {
  if (Array.isArray(transmissions)) return transmissions;
  if (typeof transmissions !== "string" || !transmissions) return [];
  try {
    const parsed = JSON.parse(transmissions);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const toTransmissionDateKey = (value) => {
  if (!value) return null;
  if (typeof value === "string") {
    const match = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (match) return match[1];
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return value.toISOString().slice(0, 10);
  }
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
};

/**
 * Distinct qualifying interaction days for musculoskeletal device CPT progress.
 * Always count every qualifying day stored on the CPT (device-cycle windows often
 * span calendar months). Month filtering caused under-counts like 6/7 days.
 */
export const getQualifyingDeviceTransmissionDates = ({
  transmissions,
  types = QUALIFYING_DEVICE_TRANSMISSION_TYPES,
} = {}) => {
  const all = parseCptTransmissions(transmissions).filter((item) =>
    types.includes(item?.type)
  );

  return [
    ...new Set(all.map((item) => toTransmissionDateKey(item?.date)).filter(Boolean)),
  ].sort();
};

/**
 * Distinct pain/medicine days for CPT 98975 initial-setup progress.
 */
export const getInitialSetupTransmissionDates = (transmissions) =>
  getQualifyingDeviceTransmissionDates({
    transmissions,
    types: QUALIFYING_SETUP_TRANSMISSION_TYPES,
  });

/**
 * Progress % for CPT 98975 — linear toward 16 qualifying data days
 * (same threshold used to approve initial setup in pain/medicine entry).
 */
export const getInitialSetupProgressPercent = ({
  loggedDays = 0,
  daysLimit = SETUP_QUALIFYING_DAYS_FOR_EXPORT,
} = {}) => {
  const limit = Number(daysLimit) > 0 ? Number(daysLimit) : SETUP_QUALIFYING_DAYS_FOR_EXPORT;
  const days = Math.max(0, Number(loggedDays) || 0);
  if (days <= 0) return 0;
  return Math.min(100, Math.round((days / limit) * 100));
};

/**
 * Progress % for 98985 / 98977:
 * - Before 2 days: progress toward 85 = days / 2
 * - At/after 2 days (toward 77): linear days / agency 77-day limit
 *   e.g. 7 of 16 days => 44%
 */
export const getMusculoskeletalDeviceProgressPercent = ({
  loggedDays = 0,
  daysLimitFor77 = DEFAULT_DAYS_LIMIT_FOR_77,
  completionStage,
} = {}) => {
  const limit = Number(daysLimitFor77) > 0 ? Number(daysLimitFor77) : DEFAULT_DAYS_LIMIT_FOR_77;
  const days = Math.max(0, Number(loggedDays) || 0);
  if (days <= 0) return 0;

  const past85Threshold =
    days >= MUSCULOSKELETAL_MIN_DAYS ||
    completionStage === "85_completed" ||
    completionStage === "77_in_progress" ||
    completionStage === "77_completed";

  if (!past85Threshold) {
    return Math.min(100, Math.round((days / MUSCULOSKELETAL_MIN_DAYS) * 100));
  }

  return Math.min(100, Math.round((days / limit) * 100));
};

// export const timeEntriesCptText = (cptCode) => {
//   if (cptCode === "98979") {
//     return {
//       minutes: 10,
//       text: "minutes of initial treatment time",
//     };
//   } else if (cptCode === "98980") {
//     return {
//       minutes: 20,
//       text: "minutes of initial treatment time",
//     };
//   }
// };

export const cptCodeTextMinutes = {
  98980: {
    minutes: 20,
    label: "minutes of initial treatment time ( 10 minutes more than 98979 )",
  },
  98981: {
    minutes: 20,
    label: "minutes of treatment time per calendar month",
  },
  98979: {
    minutes: 10,
    label: "minutes of initial treatment time",
  },
};

export const cptCodePrices = {
  98975: 21.71,
  98977: 51.44,
  98979: 26.39,
  98980: 54.11,
  98981: 41.42,
  98985: 51.44,
  99424: 80.87,
  99425: 58.87,
  99426: 61.78,
  99427: 50.46,
  99490: 62.69,
  99439: 47.44,
  99491: 85.06,
  99437: 59.98,
};

export const getCptCodePrice = (cptCode) => {
  if (cptCode == null || cptCode === "") return 0;
  return cptCodePrices[cptCode] || cptCodePrices[Number(cptCode)] || 0;
};

export const formatCptCurrency = (amount = 0) =>
  `$${Number(amount || 0).toFixed(2)}`;

export const DEVICE_CPT_CODES = ["98975", "98977", "98985", "98976", "98984"];
export const BILLING_DEVICE_CPT_CODES = ["98975", "98977", "98985"];
export const MANAGEMENT_CPT_CODES = ["98979", "98980", "98981"];

export const isDeviceCptCode = (cptCode) =>
  DEVICE_CPT_CODES.includes(String(cptCode));

export const isBillingDeviceCptCode = (cptCode) =>
  BILLING_DEVICE_CPT_CODES.includes(String(cptCode));

export const isManagementCptCode = (cptCode) =>
  MANAGEMENT_CPT_CODES.includes(String(cptCode));

export const getCptCodeSubtitleText = (cptCode) => {
  let text;
  switch (cptCode) {
    case "98975":
      text = "Remote Therapeutic Monitoring Initial Setup";
      break;
    case "98977":
      text = "Device Supply for Musculoskeletal System Monitoring";
      break;
    case "98985":
      text = "Device Supply for Musculoskeletal System Monitoring";
      break;
    case "98979":
      text = "Initial 10 mins of treatment";
      break;
    case "98980":
      text = "Initial 20 min of treatment";
      break;
    case "98981":
      text = "Additional 20 min of treatment";
      break;

    // PCM
    case "99424":
      return "First 30 min of PCM by physician";
    case "99425":
      return "Each additional 30 min of PCM by physician";
    case "99426":
      return "First 30 min of PCM by clinical staff";
    case "99427":
      return "Additional 30 min of PCM by clinical staff";

    // CCM
    case "99490":
      return "First 20 min of CCM by clinical staff";
    case "99439":
      return "Additional 20 min of CCM by clinical staff";
    case "99491":
      return "First 30 min of CCM by physician";
    case "99437":
      return "Each additional 30 min of CCM by physician";

    default:
      break;
  }

  return text;
};

export const showPhoneStatusColors = (
  status,
  ever_logged_pain,
  isEnrolled,
  credentialsSent
) => {
  if (
    (isEnrolled === "enrolled" || isEnrolled === "pending") &&
    status === "never_logged_in" &&
    credentialsSent
  ) {
    // SHOW BLACK COLOR IF - ENROLLED & CREDS SENT BUT NEVER LOGGED IN
    return <PhoneStatusIcon color="#212121" />;
  } else if (
    isEnrolled === "unenrolled" ||
    isEnrolled === "pending" ||
    (status === "pending" && status !== "never_logged_in")
  ) {
    //SHOW DISABLED COLOR IF - UNENROLLED / NOT ENROLLED & NO CREDS SENT / NOT ENROLLED & CREDS SENT
    return <PhoneStatusIcon color="rgba(0, 0, 0, 0.38)" />;
  } else if (status === "inactive" && isEnrolled !== "unenrolled") {
    // SHOW ORANGE COLOR IF - INACTIVE
    return <PhoneStatusIcon color="#FF852D" />;
  } else {
    // SHOW GREEN COLOR IF - ACTIVE
    return <PhoneStatusIcon color="#3DC583" />;
  }
};

export const phoneStatusContent = ({
  enrolments,
  enrollment_status,
  creation_flow,
  ever_logged_in,
  ever_logged_pain,
  days_since_last_login,

  patientId,
  patientName,
  patientContactNumber,
  patientEmail,
  firstLogin,
  lastAppOpened,
  appVersion,
  osVersion,
  lastReadingTime,
  openChangePasswordModalHandler,
  resendCredentialsHandler,
}) => {
  const status = getMobileAppStatus({
    enrolments,
    enrollment_status,
    creation_flow,
    ever_logged_in,
    ever_logged_pain,
    days_since_last_login,
    patientName,
  });

  // Now switch on the CALCULATED STATUS
  switch (status.title) {
    case "Mobile App - Inactive":
      return (
        <InactiveIconContent
          subtitle={status?.subtitle}
          patientId={patientId}
          patientName={patientName}
          patientContactNumber={patientContactNumber}
          patientEmail={patientEmail}
          firstLogin={firstLogin}
          lastAppOpened={lastAppOpened}
          appVersion={appVersion}
          osVersion={osVersion}
          lastReadingTime={lastReadingTime}
          ever_pain_logged={ever_logged_pain}
          openChangePasswordModalHandler={openChangePasswordModalHandler}
          resendCredentialsHandler={resendCredentialsHandler}
        />
      );

    case "Mobile App - Never Logged In":
      return (
        <PendingIconContent
          subtitle={status?.subtitle}
          is_enrolled={
            enrollment_status === "pending" || enrollment_status === "enrolled"
          }
          patientId={patientId}
          patientName={patientName}
          patientContactNumber={patientContactNumber}
          patientEmail={patientEmail}
          openChangePasswordModalHandler={openChangePasswordModalHandler}
          resendCredentialsHandler={resendCredentialsHandler}
        />
      );

    case "Mobile App - Disabled":
      return (
        <PendingIconContent
          subtitle={status?.subtitle}
          is_enrolled={false}
          patientId={patientId}
          patientName={patientName}
          patientContactNumber={patientContactNumber}
          patientEmail={patientEmail}
          isDisabled={true}
        />
      );

    case "Mobile App - Active":
    default:
      return (
        <ActiveIconContent
          subtitle={status?.subtitle}
          firstLogin={firstLogin}
          lastAppOpened={lastAppOpened}
          appVersion={appVersion}
          osVersion={osVersion}
          patientName={patientName}
          lastReadingTime={lastReadingTime}
          openChangePasswordModalHandler={openChangePasswordModalHandler}
          resendCredentialsHandler={resendCredentialsHandler}
        />
      );
  }
};

export const processSelectedItemsForAPI = (selectedItems) => {
  const cptCodes = [];

  selectedItems?.forEach((item) => {
    const cptCode = item?.slice(0, -1); // Extract numbers
    const statusSuffix = item?.slice(-1); // Extract status "G" or "P"

    cptCodes.push({
      cpt_code: cptCode,
      cpt_code_status: statusSuffix === "G" ? "generated" : "inprogress",
    });
  });

  return cptCodes;
};

export const getSortingText = (item) => {
  let itemText;
  switch (item) {
    case "newest_reading":
      itemText = "Last Reading : Newest on top";
      break;

    case "oldest_reading":
      itemText = "Last Reading : Oldest on top";
      break;

    case "newest_enrollment":
      itemText = "Enrollment Date : Newest on top";
      break;

    case "oldest_enrollment":
      itemText = "Enrollment Date : Oldest on top";
      break;

    case "newest_added_on":
      itemText = "Added On : Newest on top";
      break;

    case "oldest_added_on":
      itemText = "Added On : Oldest on top";
      break;

    default:
      itemText = "Invalid text";
      break;
  }

  return itemText;
};

export const getSortApiText = (item) => {
  let itemText;
  let order;
  switch (item) {
    case "newest_reading":
      itemText = "last_reading";
      order = "DESC";
      break;

    case "oldest_reading":
      itemText = "last_reading";
      order = "ASC";
      break;

    case "newest_enrollment":
      itemText = "enrollment_date";
      order = "DESC";
      break;

    case "oldest_enrollment":
      itemText = "enrollment_date";
      order = "ASC";
      break;

    case "newest_added_on":
      itemText = "added_on";
      order = "DESC";
      break;

    case "oldest_added_on":
      itemText = "added_on";
      order = "ASC";
      break;

    default:
      return;
  }

  return { by: itemText, order: order };
};

export const defaultProgramRates = {
  pcm: 5,
  ccm: 5,
  rtm_active: 25,
  rtm_inactive: 25,
};

export const getRateUI = (subscriptionRate, defaultRate) => {
  // fallback to default if API hasn't returned value
  if (!subscriptionRate) {
    return {
      showStrike: false,
      rate: defaultRate,
      defaultRate,
    };
  }

  if (subscriptionRate < defaultRate) {
    return {
      showStrike: true,
      rate: subscriptionRate,
      defaultRate,
    };
  }

  return {
    showStrike: false,
    rate: subscriptionRate,
    defaultRate,
  };
};

export const programCptMap = {
  RTM: {
    generated: [
      { label: "98975", value: "98975G" },
      { label: "98977", value: "98977G" },
      { label: "98980", value: "98980G" },
      { label: "98981", value: "98981G" },
    ],
    inProgress: [
      { label: "98975", value: "98975P" },
      { label: "98977", value: "98977P" },
      { label: "98980", value: "98980P" },
      { label: "98981", value: "98981P" },
    ],
  },

  PCM: {
    generated: [
      { label: "99424", value: "99424G" },
      { label: "99425", value: "99425G" },
      { label: "99426", value: "99426G" },
      { label: "99427", value: "99427G" },
    ],
    inProgress: [
      { label: "99424", value: "99424P" },
      { label: "99425", value: "99425P" },
      { label: "99426", value: "99426P" },
      { label: "99427", value: "99427P" },
    ],
  },

  CCM: {
    generated: [
      { label: "99437", value: "99437G" },
      { label: "99439", value: "99439G" },
      { label: "99490", value: "99490G" },
      { label: "99491", value: "99491G" },
    ],
    inProgress: [
      { label: "99437", value: "99437P" },
      { label: "99439", value: "99439P" },
      { label: "99490", value: "99490P" },
      { label: "99491", value: "99491P" },
    ],
  },
};

export const expenseTypeListItems = [
  {
    key: "transportExpenses",
    label: "Transport Expenses",
  },
  {
    key: "medicalExpenses",
    label: "Medical Expenses",
  },
  {
    key: "salaryLoss",
    label: "SalaryLoss",
  },
  {
    key: "others",
    label: "Others",
  },
];

export const caseTypeOptions = [
  { title: "Personal Injury", value: "personal injury" },
  { title: "Auto Accident", value: "Auto accident" },
  { title: "Slip & Fall", value: "slip-fall" },
  { title: "Premises Liability", value: "premises liability" },
  { title: "Dog Bite", value: "dog bite" },
  { title: "Pedestrian Accident", value: "pedestrian accident" },
  { title: "Other", value: "other" },
];

export const caseTypeName = {
  "personal injury": "Personal Injury",
  "Auto accident": "Auto Accident",
  "slip-fall": "Slip & Fall",
  "premises liability": "Premises Liability",
  "dog bite": "Dog Bite",
  "pedestrian accident": "Pedestrian Accident",
  other: "Other",
};

export const caseTypeValues = {
  "Personal Injury": "personal injury",
  "Auto Accident": "Auto accident",
  "Slip & Fall": "slip-fall",
  "Premises Liability": "premises liability",
  "Dog Bite": "dog bite",
  "Pedestrian Accident": "pedestrian accident",
  Other: "other",
};

export const findOptionByValue = (value) =>
  caseTypeOptions.find((option) => option.value === value) || null;

export const getNotificationText = (data) => {
  let displayText = "";

  if (data?.log_type === "appointment_update") {
    const { appointment_status, appointment_title } = data;
    displayText = (
      <span className={styles.lightText}>
        {appointment_status} {appointment_title.toLowerCase()}
      </span>
    );
  } else if (data?.log_type === "logged_in") {
    displayText = <span className={styles.lightText}>logged in</span>;
  } else if (data?.log_type === "document_uploaded") {
    displayText = (
      <span className={styles.lightText}>
        {data?.multiple_documents
          ? `uploaded documents`
          : `uploaded a document`}
      </span>
    );
  } else if (data?.log_type === "pain_logged") {
    displayText = <span className={styles.lightText}>logged pain</span>;
  } else if (data?.log_type === "case_created") {
    const { client } = data;
    displayText = (
      <span className={styles.lightText}>
        {" "}
        created a case for {client?.name}
      </span>
    );
  } else if (data?.log_type === "case_status_update") {
    const { client, case_status } = data;
    displayText = (
      <span className={styles.lightText}>
        {" "}
        updated case status to {case_status} for {client?.name}
      </span>
    );
  } else if (data?.log_type === "expense_added") {
    displayText = (
      <span className={styles.lightText}> added a new expense</span>
    );
  }
  return displayText;
};

export const getAlertNotificationText = (data) => {
  let displayText;

  if (data?.log_type === "no_pain_logged") {
    displayText = (
      <span>has not logged pain for the last {data?.number_of_days} days</span>
    );
  } else if (data?.log_type === "no_activity") {
    displayText = (
      <span>
        has not performed any activity for the last {data?.number_of_days} days
      </span>
    );
  } else if (data?.log_type === "missed_appointment_status") {
    displayText = (
      <span>
        has not updated the status of last {data?.number_of_days} appointments
      </span>
    );
  } else {
    displayText = "Unknown Log Type";
  }

  return displayText;
};

export function formatSizeUnits(bytes) {
  if (bytes >= 1073741824) {
    bytes = (bytes / 1073741824).toFixed(2) + " GB";
  } else if (bytes >= 1048576) {
    bytes = (bytes / 1048576).toFixed(2) + " MB";
  } else if (bytes >= 1024) {
    bytes = (bytes / 1024).toFixed(2) + " KB";
  } else if (bytes > 1) {
    bytes = bytes + " bytes";
  } else if (bytes === 1) {
    bytes = bytes + " byte";
  } else {
    bytes = "0 byte";
  }
  return bytes;
}

export const fileTypes = (type) => {
  if (type === "application/pdf") {
    return pdfImg;
  } else if (
    type === "image/png" ||
    type === "image/jpg" ||
    type === "image/jpeg"
  ) {
    return Img;
  } else {
    return docImg;
  }
};

export function caseStatusType(type) {
  if (type?.toLowerCase() === "open" || type?.toLowerCase() === "sent") {
    return "primary";
  } else if (type?.toLowerCase() === "closed") {
    return "error";
  } else if (type?.toLowerCase() === "on hold") {
    return "warning";
  } else {
    return "success";
  }
}

export function patientStatus(status) {
  if (status === "active") {
    return "primary";
  } else {
    return "warning";
  }
}

export const customRangeOptions = [
  { title: "Last 3 Months", value: "last_3_months" },
  { title: "Last 6 Months", value: "last_6_months" },
  { title: "Last 12 Months", value: "last_12_months" },
  { title: "Since Last Appt.", value: "since_last_appt" },
];

export function formatCaseTypeText(text) {
  // Replace underscores and hyphens with space and capitalize the first letter of each word
  const formattedText = text
    .replace(/[_-]/g, " & ")
    .replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  return formattedText;
}

export function notificationStatusColor(status) {
  if (status.toLowerCase() === "sent") {
    return "success";
  } else if (status.toLowerCase() === "scheduled") {
    return "primary";
  } else if (status.toLowerCase() === "on hold") {
    return "warning";
  } else {
    return "error";
  }
}

export const uniqueEnrolmentsKey = (row) => {
  const enrolments = row?.enrolments || [];
  const programMap = new Map();

  const STATUS_PRIORITY = {
    enrolled: 3,
    pending: 2,
    unenrolled: 1,
  };

  enrolments.forEach((enrol) => {
    const key = enrol.care_program_key;
    const status = enrol.enrolment_status;

    // If program not seen yet, store it
    if (!programMap.has(key)) {
      programMap.set(key, enrol);
      return;
    }

    const existing = programMap.get(key);

    // Replace only if current has higher priority
    if (STATUS_PRIORITY[status] > STATUS_PRIORITY[existing.enrolment_status]) {
      programMap.set(key, enrol);
    }
  });

  return Array.from(programMap.values());
};

// export function referralStatusColor(status) {
//   let color;
//   if (status.toLowerCase() === "sent") {
//     color = "#2196F3";
//   } else if (status.toLowerCase() === "completed") {
//     color = "#2E7D32";
//   } else {
//     color = "#FAD44D";
//   }
//   return color;
// }

export const caseValueColor = (value) => {
  let color;
  switch (value) {
    case "high":
      color = "#D32F2F";
      break;
    case "low":
      color = "#649F67";
      break;
    case "moderate":
      color = "#F29244";
      break;
    default:
      break;
  }

  return color;
};

export const caseValueBgColor = (value) => {
  let color;
  switch (value) {
    case "high":
      color = "rgba(211, 47, 47, 0.15)";
      break;
    case "low":
      color = "rgba(100, 159, 103, 0.15)";
      break;
    case "moderate":
      color = "rgba(242, 146, 68, 0.15)";
      break;
    default:
      break;
  }

  return color;
};

export const notesOptions = [
  {
    title: "All",
    value: "all",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "Session",
    value: "time_entry",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "Custom Notes",
    value: "custom_note",
    borderColor: "#FF852D",
    bgColor: "rgba(255, 133, 45, 0.08)",
    hoverBgColor: "#FF852D",
  },
  {
    title: "Enrollment",
    value: "enrollment",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "Medical History",
    value: "medical_history",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
];

export const reporCptOptions = [
  {
    title: "All",
    value: "all",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "98975",
    value: "98975",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "98977",
    value: "98977",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "98985",
    value: "98985",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "98979",
    value: "98979",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "98980",
    value: "98980",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
  {
    title: "98981",
    value: "98981",
    borderColor: "#1669BB",
    bgColor: "#E3F1FF",
    hoverBgColor: "#1669BB",
  },
];

export const invoiceStatus = (status) => {
  let label, bgColor, color, text;
  switch (status) {
    case "unpaid":
      label = "Unpaid";
      bgColor = "#FFF2E9";
      color = "#FF852D";
      text = "Attempted on";
      break;
    case "paid":
      label = "Paid";
      bgColor = "#D1FFE2";
      color = "#3DC583";
      text = "Paid on";
      break;
    case "ready_to_charge":
      label = "Open";
      bgColor = "rgba(12, 128, 243, 0.08)";
      color = "#0C80F3";
      text = "Due on";
      break;
    default:
      label = "Invalid";
      bgColor = "rgba(12, 128, 243, 0.08)";
      color = "#0C80F3";
      text = "Invalid";
      break;
  }

  return { label, bgColor, color, text };
};

export const monthInvoices = [
  {
    id: 1,
    organization_id: 1,
    total_amount: 100,
    number_of_patients: 10,
    status: "unpaid", // paid, unpaid, ready_to_charge
    // paid_at: "2021-01-01T00:00:00Z",
    month: "November",
    year: "2024",
    created_at: "2021-01-01T00:00:00Z",
    invoice_url: "https://www.google.com",
    practice_breakdown: [
      {
        agency_id: 1,
        name: "Abc",
        number_of_patients: 10,
        amount: 50,
        invoice_id: 1,
      },
      {
        agency_id: 1,
        name: "Xyz",
        number_of_patients: 5,
        amount: 25,
        invoice_id: 1,
      },
    ],
  },
  {
    id: 2,
    organization_id: 1,
    total_amount: 50,
    number_of_patients: 5,
    status: "paid", // paid, unpaid, ready_to_charge
    paid_at: "2021-01-01T00:00:00Z",
    month: "October",
    year: "2024",
    created_at: "2021-01-01T00:00:00Z",
    invoice_url: "https://www.google.com",
    practice_breakdown: [
      {
        agency_id: 1,
        name: "POQ",
        number_of_patients: 10,
        amount: 50,
        invoice_id: 1,
      },
      {
        agency_id: 1,
        name: "ROS",
        number_of_patients: 5,
        amount: 25,
        invoice_id: 1,
      },
    ],
  },
  {
    id: 3,
    organization_id: 1,
    total_amount: 75,
    number_of_patients: 20,
    status: "ready_to_charge", // paid, unpaid, ready_to_charge
    // paid_at: "2021-01-01T00:00:00Z",
    month: "September",
    year: "2024",
    created_at: "2021-01-01T00:00:00Z",
    invoice_url: "https://www.google.com",
    practice_breakdown: [
      {
        agency_id: 1,
        name: "TEST",
        number_of_patients: 10,
        amount: 50,
        invoice_id: 1,
      },
      {
        agency_id: 1,
        name: "TEST 2",
        number_of_patients: 5,
        amount: 25,
        invoice_id: 1,
      },
    ],
  },
  {
    id: 4,
    organization_id: 1,
    total_amount: 120,
    number_of_patients: 50,
    status: "paid", // paid, unpaid, ready_to_charge
    // paid_at: "2021-01-01T00:00:00Z",
    month: "August",
    year: "2024",
    created_at: "2021-01-01T00:00:00Z",
    invoice_url: "https://www.google.com",
    practice_breakdown: [
      {
        agency_id: 1,
        name: "XYZ 1",
        number_of_patients: 10,
        amount: 50,
        invoice_id: 1,
      },
      {
        agency_id: 1,
        name: "XYZ 2",
        number_of_patients: 5,
        amount: 25,
        invoice_id: 1,
      },
    ],
  },
];

export const getNotesColor = (value) => {
  let color;
  switch (value) {
    case "timer":
      color = "#0C80F3";
      break;
    case "custom_note":
      color = "#FF852D";
      break;
    case "enrollment":
      color = "#0C80F3";
      break;

    default:
      color = "#0C80F3";
      break;
  }

  return color;
};

export const getNotesBackgroundColor = (value) => {
  let bgcolor;
  switch (value) {
    case "timer":
      bgcolor = "rgba(12, 128, 243, 0.08)";
      break;
    case "custom_note":
      bgcolor = "rgba(255, 133, 45, 0.08)";
      break;
    case "enrollment":
      bgcolor = "rgba(12, 128, 243, 0.08)";
      break;

    default:
      bgcolor = "rgba(12, 128, 243, 0.08)";
      break;
  }

  return bgcolor;
};

export const caseStatusColor = (value) => {
  let color;
  switch (value) {
    case "closed":
      color = "#D32F2F";
      break;
    case "settled":
      color = "#649F67";
      break;
    case "on hold":
      color = "#F29244";
      break;
    case "open":
      color = "#0C80F3";
      break;
    default:
      break;
  }

  return color;
};

export const caseStatusBgColor = (value) => {
  let color;
  switch (value) {
    case "closed":
      color = "rgba(211, 47, 47, 0.15)";
      break;
    case "settled":
      color = "rgba(100, 159, 103, 0.15)";
      break;
    case "on hold":
      color = "rgba(242, 146, 68, 0.15)";
      break;
    case "open":
      color = "rgba(12, 128, 243, 0.15)";
      break;
    default:
      break;
  }

  return color;
};

export const caseLogsCategory = {
  pain_logged: "General",
  document_uploaded: "General",
  appointment_update: "Appointment",
  case_status_update: "System",
  case_created: "System",
  custom_note: "Note",
  expense_added: "Expense",
};

export function stepperIcon(type) {
  if (type === "enrolled" || type === "consent_taken") {
    return "#3DC583";
  } else if (type === "unenrolled") {
    return "#F54949";
  } else {
    return "#0C80F3";
  }
}

const log_type_title_config = {
  pain_logged: "Pain Logged",
  case_created: "Case Created",
  appointment_update: "",
  case_status_update: "Case Status changed to ",
  document_uploaded: "Uploaded a Document",
  chat_activity: "Client replied in chat",
};

export const expenseTypeValuesStatement = {
  other: "Other Expense",
  transport_expense: "Transport Expense",
  medical_expense: "Medical Expense",
  salary_loss: "Salary Loss",
};

export const painDurationValues = {
  all_day: "All Day",
  hours_0_1: "0-1 Hours",
  hours_1_3: "1-3 Hours",
  hours_3_10: "3-10 Hours",
  hours_10_20: "10-20 Hours",
};

export const renderStepContent = (step, patient) => {
  switch (step.event_type) {
    case "enrolled":
      return `Enrolled in ${step?.care_program_key}`;
    case "unenrolled":
      return `Unenrolled from ${step?.care_program_key}`;
    case "consent_taken":
      return `Consented for ${step?.care_program_key}`;
    case "patient_creation":
      return `${patient?.name} Added`;
    default:
      return step.event_type;
  }
};

export const enrollmentJourneyPatientText = (patient) => {
  switch (patient?.creation_flow) {
    case "bulk_import":
      return "Bulk Import";
    case "self_signup":
      return "Self Signup";
    default:
      return "Added Manually";
  }
};

export const painLevelBackgroundColor = (painLevel) => {
  let bgColor;
  switch (painLevel) {
    case 0:
      bgColor = "#43A762";
      break;
    case 1:
      bgColor = "#9ECA46";
      break;
    case 2:
      bgColor = "#E6E62F";
      break;
    case 3:
      bgColor = "#E6E630";
      break;
    case 4:
      bgColor = "#E6E62F";
      break;
    case 5:
      bgColor = "#E8C929";
      break;
    case 6:
      bgColor = "#E9AB22";
      break;
    case 7:
      bgColor = "#E8921B";
      break;
    case 8:
      bgColor = "#E67612";
      break;
    case 9:
      bgColor = "#E85014";
      break;
    case 10:
      bgColor = "#E91416";
      break;
    default:
      return "#000";
  }

  return bgColor;
};

export const lastMonthCreatedCases = (cases, month) => {
  const expectedMonth = dayjs().subtract(month, "month");

  const casesCreatedLastMonth = cases?.filter((caseItem) =>
    dayjs(caseItem.created_at).isAfter(expectedMonth)
  );

  return casesCreatedLastMonth;
};

export const groupedEntriesFunc = (timeEntriesArr) => {
  const tz = getUserTimezone();

  return timeEntriesArr?.reduce((acc, entry) => {
    const date = entry?.date
      ? dayjs(entry.date).tz(tz).format("YYYY-MM-DD")
      : "";
    const timeInSeconds = entry?.time_in_seconds;
    if (!acc[date]) {
      acc[date] = { totalTime: 0, entries: [] };
    }
    acc[date].entries?.push(entry);
    acc[date].totalTime += timeInSeconds;

    return acc;
  }, {});
};

export const groupedByMonth = (items) => {
  const groups = {};

  items?.forEach((item) => {
    const monthKey = dayjs(item?.created_at).format("MMMM YYYY");

    if (!groups[monthKey]) {
      groups[monthKey] = [];
    }

    groups[monthKey].push(item);
  });

  const sortedKeys = Object.keys(groups).sort(
    (a, b) => dayjs(b, "MMMM YYYY").toDate() - dayjs(a, "MMMM YYYY").toDate()
  );

  return sortedKeys?.map((key) => ({
    month: key,
    items: groups[key],
  }));
};

const avatarColors = [
  "#B2D7FD",
  "#FECDAA",
  "#A4EDC9",
  "#D5BDF7",
  "#F6A0A0",
  "#F6D68D",
];

export const getRandomAvatarBackgroundColor = () => {
  return avatarColors[Math.floor(Math.random() * avatarColors.length)];
};

export const getReportStatus = (status) => {
  if (status === "attended") {
    return { color: "#2E9E68", text: "Attended" };
  } else if (status === "missed") {
    return { color: "#B74242", text: "Missed" };
  } else if (status === "rescheduled") {
    return { color: "#2E9E68", text: "Rescheduled" };
  }
};

export const getCptDateRanges = (filterValue) => {
  let startDate, endDate;

  if (filterValue === "this_month") {
    startDate = dayjs()?.startOf("month")?.format("YYYY-MM-DD");
    endDate = dayjs().format("YYYY-MM-DD");
  } else if (filterValue === "last_month") {
    startDate = dayjs()
      ?.subtract(1, "month")
      ?.startOf("month")
      ?.format("YYYY-MM-DD");
    endDate = dayjs()
      ?.subtract(1, "month")
      ?.endOf("month")
      ?.format("YYYY-MM-DD");
  }

  return { startDate, endDate };
};

export const getReportDateRanges = (filterValue) => {
  let startDate, endDate;
  const now = nowInUserTimezone();

  if (filterValue === "this_month") {
    startDate = now.startOf("month").format("YYYY-MM-DD");
    endDate = now.format("YYYY-MM-DD");
  } else if (filterValue === "last_month") {
    const lastMonth = now.subtract(1, "month");
    startDate = lastMonth.startOf("month").format("YYYY-MM-DD");
    endDate = lastMonth.endOf("month").format("YYYY-MM-DD");
  } else if (filterValue.length === 7) {
    // Example for "2024-06" format
    startDate = dayjs.tz(`${filterValue}-01`, getUserTimezone())
      .startOf("month")
      .format("YYYY-MM-DD");
    endDate = dayjs.tz(`${filterValue}-01`, getUserTimezone())
      .endOf("month")
      .format("YYYY-MM-DD");
  }

  return { startDate, endDate };
};

export const getEvidenceDownloadDateRanges = (filterValue, enrolledDate) => {
  let startDate, endDate;
  const now = nowInUserTimezone();

  if (filterValue === "this_month") {
    startDate = now.startOf("month").format("YYYY-MM-DD");
    endDate = now.format("YYYY-MM-DD");
  } else {
    startDate = dayjs.tz(`${filterValue}-01`, getUserTimezone())
      .startOf("month")
      .format("YYYY-MM-DD");
    endDate = dayjs.tz(`${filterValue}-01`, getUserTimezone())
      .endOf("month")
      .format("YYYY-MM-DD");
  }

  if (enrolledDate && dayjs(enrolledDate).isSame(startDate, "month")) {
    startDate = dayjs(enrolledDate).format("YYYY-MM-DD");
  }

  return { startDate, endDate };
};

export const timeFormat = (time) => {
  const formattedTime = dayjs(time)?.format("hh:mm A");
  return formattedTime;
};

export const dateFormat = (date) => {
  const formattedDate = dayjs(date)?.format("MM/DD/YYYY");
  return formattedDate;
};

export const dateFormatHyphen = (date) => {
  const formattedDate = dayjs(date).format("MM-DD-YYYY");
  return formattedDate;
};

export const dateTimeFormat = (dateTimeString) => {
  const formattedDateTime = dayjs(dateTimeString)?.format("hh:mm A, D MMMM");
  return formattedDateTime;
};

export const shortDateTimeFormat = (dateTimeString) => {
  const formattedDateTime = dayjs(dateTimeString)?.format("hh:mm A, D MMM");
  return formattedDateTime;
};

export const timeDateFormat = (dateTimeString) => {
  const formattedDateTime = dayjs(dateTimeString).format("D MMMM, hh:mm A");
  return formattedDateTime;
};

export const shortDateFormat = (dateTimeString) => {
  const formattedDateTime = dayjs(dateTimeString)?.format("D MMM, hh:mm A");
  return formattedDateTime;
};
export const onlyDateFormat = (dateTimeString) => {
  const formattedDateTime = dayjs(dateTimeString).format("MMM D, YYYY");
  return formattedDateTime;
};
export const dateWithoutYearFormat = (dateTimeString) => {
  const formattedDateTime = dayjs(dateTimeString).format("D MMM");
  return formattedDateTime;
};

export const extractDate = (date) => {
  const stringDate = dayjs(date).format("DD");
  return stringDate;
};

export const extractMonth = (date) => {
  const month = dayjs(date).format("MMM");
  return month;
};

export const parseAndMergeBodyParts = (bodyPartsArrays) => {
  let mergedBodyParts = [];

  bodyPartsArrays?.forEach((bodyPart) => {
    mergedBodyParts = [...mergedBodyParts, ...bodyPart];
  });

  return mergedBodyParts;
};

export function displayExpenseAmounts(expenseDetails) {
  let transportExpenseAmount = 0;
  let medicalExpenseAmount = 0;
  let salaryLossAmount = 0;
  let otherAmount = 0;

  expenseDetails?.forEach((expense) => {
    switch (expense.expense_type) {
      case "transport_expense":
        transportExpenseAmount += expense.total_amount;
        break;
      case "medical_expense":
        medicalExpenseAmount += expense.total_amount;
        break;
      case "salary_loss":
        salaryLossAmount += expense.total_amount;
        break;
      default:
        otherAmount += expense.total_amount;
        break;
    }
  });

  return {
    transportExpenseAmount,
    medicalExpenseAmount,
    salaryLossAmount,
    otherAmount,
  };
}

export function showExpenseTypeName(expenseType) {
  switch (expenseType) {
    case "transport_expense":
      return "Transport";
    case "medical_expense":
      return "Medical";
    case "salary_loss":
      return "Salary Loss";
    case "other":
      return "Other";
    default:
      break;
  }
}
export function showNotesType(note) {
  let noteType;
  switch (note) {
    case "custom_note":
      noteType = "Custom Notes";
      break;
    case "medical_history":
      noteType = "Medical History";
      break;
    case "enrollment":
      noteType = "Enrollment";
      break;
    case "unenrollment":
      noteType = "Unenrollment";
      break;
    default:
      noteType = "Enrollment";
      break;
  }

  return noteType;
}

export const expenseTypeValues = {
  transport_expense: "transportExpenses",
  medical_expense: "medicalExpenses",
  salary_loss: "salaryLoss",
  other: "others",
};

export function balancedPercentages(values) {
  const total = values.reduce((sum, v) => sum + v, 0);

  if (total === 0) {
    return values.map(() => 0);
  }

  // 1. Calculate exact percentages
  const exact = values.map((v) => (v / total) * 100);

  // 2. Floor all percentages
  const floored = exact.map((v) => Math.floor(v));

  // 3. Calculate remaining points needed to reach 100
  let remainder = 100 - floored.reduce((sum, v) => sum + v, 0);

  // 4. Sort by largest fractional remainder
  const decimalParts = exact
    .map((v, i) => ({
      index: i,
      decimal: v - Math.floor(v),
    }))
    .sort((a, b) => b.decimal - a.decimal);

  // 5. Distribute leftover percentage points
  for (let i = 0; i < remainder; i++) {
    floored[decimalParts[i].index] += 1;
  }

  return floored;
}
